import type { BlogPostPreview } from '@/lib/api/blog';

// Дата статьи на сайте: дата источника, если она известна. Архивным материалам без неё
// дату не приписываем — их published_at означает перенос на сайт, а не выход статьи.
// Старый бэк source_date не присылает — тогда, как раньше, published_at.
export function blogArticleDate(
  post: Pick<BlogPostPreview, 'source_date' | 'published_at' | 'is_archive'>
): string | null {
  return post.source_date ?? (post.is_archive ? null : post.published_at || null);
}
